export default "__VITE_ASSET__BF2DwW6h__"